import { useState } from 'react';
import { getDataUrl } from '../utils/apiConfig';
import './CompareWorkshops.css';

const CompareWorkshopsRowImage = ({ title, titleBadge, comparedWorkshops, workshopDetails, property, imgPath }) => {
        
    const [isModalActive, setIsActive] = useState(false);
    const [isRowLayout, setIsRowLayout] = useState(true);
    
    const toggleModal = () => {
        setIsActive(!isModalActive);
    };
    
    const toggleLayout = () => {
        setIsRowLayout(!isRowLayout);
    };

    const base = getDataUrl();    

    return (
        <div className="columns">
            <div className='column is-2 mt-3 mb-3'>
                <div className='title is-5'>
                    {title}
                </div>
                {titleBadge && <span className="tag is-light">{titleBadge}</span>}
            </div>
            {comparedWorkshops.map((workshop, index) => (
                <div key={workshop.id} className='column'>
                    <div className="image comparison-chart-image" onClick={toggleModal}>
                        <img
                            src={`${base}/${workshop.name}${imgPath}`}
                            alt=""
                        />
                    </div>
                </div>
            ))}
            
            {/* Modal for enlarged view of all compared charts */}
            <div className={`modal ${isModalActive ? 'is-active' : ''}`}>        
                <div className="modal-background" onClick={toggleModal}></div>
                <button className="modal-close is-large modal-close-margin" aria-label="close" onClick={toggleModal}></button>
                <div className="modal-content comparison-modal-content">
                    <div className='block p-6'>
                        <div className="level mb-5">
                            <div className="level-left">
                                <h3 className="title is-4 has-text-white">{title} - Comparison</h3>
                            </div>
                            <div className="level-right">
                                <div className="field" style={{ position: 'relative' }}>
                                    <input 
                                        id="layoutSwitch" 
                                        type="checkbox" 
                                        name="layoutSwitch" 
                                        className="switch" 
                                        checked={!isRowLayout}
                                        onChange={toggleLayout}
                                    />
                                    <label htmlFor="layoutSwitch" className="has-text-white is-size-7">
                                        Column View
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className={isRowLayout ? "columns" : "columns is-multiline"}>
                            {comparedWorkshops.map((workshop, index) => (
                                <div key={workshop.id} className={isRowLayout ? 'column' : 'column is-full mt-5'}>
                                    <figure className="image comparison-modal-chart">
                                        <img
                                            src={`${base}/${workshop.name}${imgPath}`}
                                            alt={`${title} for ${workshop.name}`}
                                        />
                                    </figure>
                                    <div className="has-text-centered mt-3">
                                        <h4 className="subtitle is-6 has-text-white">{workshop.name}</h4>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>          
                </div>
                <button className="modal-close is-large" aria-label="close" onClick={toggleModal}></button>
            </div>
        </div>
    );
};

export default CompareWorkshopsRowImage;
